import traceConfigs from "./traceConfigs";
import initPiwik from "./items/piwik";
import init51la from "./items/la51";
import initGA from "./items/ga";

const setupTraces = (pageName) => {
  if (typeof window !== 'undefined') {
    window.globalConsole = function(...args) {
      console.log.apply(null, args);
    }

    console.log('===setupTraces',pageName);
    const thisConfig = traceConfigs[pageName];
    if (thisConfig) {
      if (thisConfig.piwik) {
        initPiwik(thisConfig.piwik);
      }
      if (thisConfig['51la']) {
        init51la(thisConfig['51la']);
      }
      if (thisConfig.ga) {
        initGA(thisConfig.ga);
      }
    }
  }
}

export default setupTraces;
